export type CompanyRole = 'OWNER' | 'TEAM_LEADER' | 'MEMBER' | 'GUEST' | string;

export const COMPANY_ROLE_LABEL: Record<string, string> = {
  OWNER: '오너',
  TEAM_LEADER: '팀장',
  MEMBER: '멤버',
  GUEST: '게스트',
};

export function companyRoleLabel(role?: string | null) {
  if (!role) return '-';
  return COMPANY_ROLE_LABEL[role] ?? role;
}

export function canManageContracts(role?: string | null) {
  return role === 'OWNER' || role === 'TEAM_LEADER';
}

export function canConfirmInspection(role?: string | null) {
  return role === 'OWNER' || role === 'TEAM_LEADER';
}

export function isGuest(role?: string | null) {
  return role === 'GUEST';
}

/** 게스트는 읽기 전용 */
export function isGuestReadOnly(role?: string | null) {
  return isGuest(role);
}
